'use strict';

/*global BasicQueue*/

function MismatchProcessingQueue(containerId) {
  BasicQueue.call(this, containerId);

  this.init();
}

MismatchProcessingQueue.prototype = $.extend({}, BasicQueue.prototype, {
  constructor: 'MismatchProcessingQueue',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.processBulkAction = 'mismatch_processing_process';

    _this.registerCallbacks();

    return _this;
  }
});
